<div class="blueBackground text-center">
    <div class="col-xs-12 whiteText pt-5" style="padding-right:0px; padding-left:0px; padding-top:5%">
        <h3 class="Caecilia76BoldItalic" style="font-size: 28pt; font-weight: 700;">
            Ready to Become a Customer?</h3>
        <h6 class="DIN2014Regular whiteText"
            style="text-align:center; margin-left:20%; margin-right:20%; font-size: 16px; line-height: 22px; font-weight: 700; color:#FFFFFC; opacity: 55%; padding-bottom:20px">
            Submit the form below and we will reach out to you with more information.</h6>
    </div>
    <div class="row letUsFormContainer">
        <!-- <div id="hubspotFindRepForm" style="width:430px; margin:auto; color:white">hubspot form here</div> -->
        <div class="row" style="margin:auto; padding-bottom:20px">
            <input type="text" placeholder="First Name*"
                class="whitePlaceholder blueBackground whiteText Din2014Regular"
                style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                [(ngModel)]="this.firstNameRepMatch">
            <input type="text" placeholder="Last Name*"
                class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                [(ngModel)]="this.lastNameRepMatch">
        </div>
        <div class="row" style="margin:auto;padding-bottom:26px">
            <input type="text" placeholder="Company Name*"
                class="whitePlaceholder blueBackground whiteText Din2014Regular"
                style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                [(ngModel)]="this.companyRepMatch">
            <input type="text" placeholder="Job Title*"
                class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                [(ngModel)]="this.titleRepMatch">
        </div>
        <div class="row" style="margin:auto; padding-bottom:20px">
            <input type="number" placeholder="Phone Number*"
                style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                class="whitePlaceholder blueBackground whiteText Din2014Regular" [(ngModel)]="this.phoneRepMatch">
            <input type="text" placeholder="Email*"
                class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                [(ngModel)]="this.emailRepMatch">
        </div>
        <div class="row" style="margin:auto; padding-bottom:20px">
            <input type="text" placeholder="City*"
                style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                class="whitePlaceholder blueBackground whiteText Din2014Regular" [(ngModel)]="this.cityRepMatch">
            <input type="text" placeholder="State*"
                class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                [(ngModel)]="this.stateRepMatch">
        </div>
        <div class="row" style="margin:auto; padding-bottom:20px">
            <input type="text" placeholder="Zip*"
                style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                class="whitePlaceholder blueBackground whiteText Din2014Regular" [(ngModel)]="this.zipRepMatch">
        </div>

        <h4 class="Din2014Regular whiteText"
            style="margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
            Choose
            Your Market(s)*</h4>

        <div class="matchRepCheckboxContainer">
            <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="golfRepMatch"
                (change)="golfRepMatch = !golfRepMatch">
            <h4 class="Din2014Regular whiteText"
                style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                Golf</h4>
        </div>
        <div class="matchRepCheckboxContainer">
            <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="horticultureRepMatch"
                (change)="horticultureRepMatch = !horticultureRepMatch">
            <h4 class="Din2014Regular whiteText"
                style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                Horticulture</h4>
        </div>
        <div class="matchRepCheckboxContainer">
            <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="sportsTurfRepMatch"
                (change)="sportsTurfRepMatch = !sportsTurfRepMatch">
            <h4 class="Din2014Regular whiteText"
                style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                Sports Turf</h4>
        </div>
        <div class="matchRepCheckboxContainer">
            <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="specialtyAgRepMatch"
                (change)="specialtyAgRepMatch = !specialtyAgRepMatch">
            <h4 class="Din2014Regular whiteText"
                style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                Specialty Ag</h4>
        </div>
        <div class="matchRepCheckboxContainer">
            <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="lawnCareRepMatch"
                (change)="lawnCareRepMatch = !lawnCareRepMatch">
            <h4 class="Din2014Regular whiteText"
                style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                Lawn Care</h4>
        </div>

        <textarea class="whitePlaceholder blueBackground whiteText DIN2014Regular textareaCanWeHelpMobile"
            [(ngModel)]="this.commentsRepMatch" style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; 
            letter-spacing:.38px; font-weight:400; 
            border: 1px solid #FFF;width:95%; height:100px; margin:auto"
            placeholder="How Can We Help?"></textarea>
        <div class="row whiteBackground"
            style="margin-top:26px; text-align: center;width:auto; margin-left:10px; padding:0px">
            <button class="DINNextLTPro-Black blueText"
                [disabled]="this.firstNameRepMatch == '' || this.lastNameRepMatch == '' || this.emailRepMatch == '' || this.phoneRepMatch == '' || this.companyRepMatch == '' || this.titleRepMatch == '' || this.cityRepMatch == '' || this.stateRepMatch == ''|| this.zipRepMatch == ''"
                [ngClass]="this.firstNameRepMatch == '' || this.lastNameRepMatch == '' || this.emailRepMatch == '' || this.phoneRepMatch == '' || this.companyRepMatch == '' || this.titleRepMatch == '' || this.cityRepMatch == '' || this.stateRepMatch == ''|| this.zipRepMatch == '' ? 'greyDisabled':'' "
                style="padding:10px 10px 7px 10px;font-size:20px; font-weight: 900; line-height:normal; text-decoration: none !important"
                (click)="sendEmail()">SUBMIT</button>
        </div>

    </div>
</div>